import React, { Component } from 'react';
import { Box, List, ListItemButton, ListItemIcon, ListItemText, Tooltip, IconButton, Divider } from '@mui/material';
import { Assessment, ReportProblem, People, ChevronLeft, ChevronRight } from '@mui/icons-material';
import CsReport from './CsReport';
import CsReportMonitoringIssueCo from './CsReportMonitoringIssueCo';
import CsAgentsPerformancesReport from './CsAgentsPerformancesReport';

const MENU_ITEMS = [
    { value: 'tab-monitoring-issue-co', label: 'Monitoring Issue CO', icon: <ReportProblem sx={{ fontSize: 20 }} /> },
    { value: 'tab-agents-performance', label: 'Agents Performance', icon: <People sx={{ fontSize: 20 }} /> },
    { value: 'tab-cs-report', label: 'Cs Report', icon: <Assessment sx={{ fontSize: 20 }} /> },
];

const EXPANDED_WIDTH = 220;
const COLLAPSED_WIDTH = 60;

class CsReportWrapper extends Component {
    state = {
        activeTab: 'tab-monitoring-issue-co',
        menuExpanded: true,
    }

    handleMenuSelect = (value) => {
        this.setState({ activeTab: value });
    }

    toggleMenu = () => {
        this.setState((prev) => ({ menuExpanded: !prev.menuExpanded }));
    }

    render() {
        const { activeTab, menuExpanded } = this.state;
        const menuWidth = menuExpanded ? EXPANDED_WIDTH : COLLAPSED_WIDTH;

        return (
            <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                <Box
                    sx={{
                        width: menuWidth,
                        flexShrink: 0,
                        bgcolor: '#f0f2f5',
                        borderRadius: '8px',
                        p: 0.5,
                        mr: '10px',
                        transition: 'width 0.25s ease',
                        overflow: 'hidden',
                    }}
                >
                    <Box sx={{ display: 'flex', justifyContent: menuExpanded ? 'flex-end' : 'center', mb: 0.5 }}>
                        <IconButton size="small" onClick={this.toggleMenu} aria-label={menuExpanded ? 'Minimize menu' : 'Expand menu'}>
                            {menuExpanded ? <ChevronLeft fontSize="small" /> : <ChevronRight fontSize="small" />}
                        </IconButton>
                    </Box>
                    <Divider sx={{ mb: 0.5 }} />
                    <List sx={{ p: 0 }}>
                        {MENU_ITEMS.map((item) => {
                            const selected = activeTab === item.value;
                            const button = (
                                <ListItemButton
                                    key={item.value}
                                    selected={selected}
                                    onClick={() => this.handleMenuSelect(item.value)}
                                    sx={{
                                        minHeight: 36,
                                        borderRadius: '8px',
                                        mb: 0.5,
                                        justifyContent: menuExpanded ? 'flex-start' : 'center',
                                        px: menuExpanded ? 1.5 : 1,
                                        fontWeight: 600,
                                        transition: 'all 0.25s ease',
                                        '&.Mui-selected': {
                                            color: '#fff',
                                            bgcolor: 'primary.main',
                                            boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
                                        },
                                        '&.Mui-selected:hover': {
                                            bgcolor: 'primary.main',
                                        },
                                    }}
                                >
                                    <ListItemIcon
                                        sx={{
                                            minWidth: 0,
                                            mr: menuExpanded ? 1.5 : 0,
                                            justifyContent: 'center',
                                            color: selected ? '#fff' : 'text.secondary',
                                        }}
                                    >
                                        {item.icon}
                                    </ListItemIcon>
                                    {menuExpanded && (
                                        <ListItemText
                                            primary={item.label}
                                            primaryTypographyProps={{ fontSize: '0.85rem', fontWeight: 600, noWrap: true }}
                                        />
                                    )}
                                </ListItemButton>
                            );

                            return menuExpanded ? button : (
                                <Tooltip key={item.value} title={item.label} placement="right">
                                    {button}
                                </Tooltip>
                            );
                        })}
                    </List>
                </Box>

                <Box sx={{ flexGrow: 1, minWidth: 0, maxWidth: '100%', overflowX: 'auto' }}>
                    {activeTab === 'tab-cs-report' && <CsReport />}
                    {activeTab === 'tab-monitoring-issue-co' && <CsReportMonitoringIssueCo />}
                    {activeTab === 'tab-agents-performance' && <CsAgentsPerformancesReport />}
                </Box>
            </Box>
        );
    }
}

export default CsReportWrapper;
